export default {
      id: "i-lk-nav-open-usage",
      viewBox: "0 0 12 14",
      url: __webpack_public_path__ + "img/sprite.svg#i-lk-nav-open",
      toString: function () {
        return this.url;
      }
    }